var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHpdTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.923065 23.0771H10.8092",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74768 6.41602H14.8615",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74768 12.1484H8.87076",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12 23.0777V3.12075C3.12 2.53921 3.35076 1.97614 3.76615 1.56998C4.18153 1.16383 4.73538 0.923828 5.31692 0.923828H16.3015C16.8831 0.923828 17.4461 1.1546 17.8523 1.56998C18.2585 1.98537 18.4985 2.53921 18.4985 3.12075V7.29306",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0461 15.1758L20.2061 16.0158",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5262 17.6963L17.6862 18.5363",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0154 20.207L15.1754 21.047",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8554 10.976L22.7354 16.856C23.1969 17.3176 23.1969 18.0745 22.7354 18.536L21.48 19.7914C21.0185 19.3299 20.2615 19.3299 19.8 19.7914C19.3385 20.253 19.3385 21.0099 19.8 21.4714L18.5446 22.7268C18.0831 23.1883 17.3262 23.1883 16.8646 22.7268L10.9846 16.8468C10.5231 16.3853 10.5231 15.6283 10.9846 15.1668L12.24 13.9114C12.7015 14.373 13.4585 14.373 13.92 13.9114C14.3815 13.4499 14.3815 12.693 13.92 12.2314L15.1754 10.976C15.6369 10.5145 16.3938 10.5145 16.8554 10.976Z",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpdTickets);
export default __webpack_public_path__ + "static/media/hpd-tickets.16d337091250d78043fc01953a0a5f59.svg";
export { ForwardRef as ReactComponent };